import jsPDF from "jspdf";

export class PdfSpaceElement {
  private width: number;
  private height: number;
  public readonly newPage: boolean;

  constructor(width: number, height: number, newPage: boolean = false) {
    this.width = width;
    this.height = height;
    this.newPage = newPage;
  }

  public async render(doc: jsPDF, x: number, y: number, maxWidth: number): Promise<number> {
    return this.height;
  }
}
